import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Dropdown, notification, Switch } from 'antd';
import Icon from '../../atoms/global/Icon';
import ProfileAndName from '../../atoms/ticket-drawer/ProfileAndName';
import WorkspaceSearchBar from './WorkspaceSearchBar';

import { getWorkspaceNotifications } from '../../../../redux/state-areas/notifications/actions';
import {
  editProject,
  getUser,
  updateProjectPreferences,
  isChatSettingsOpen,
  getWorkspaceById,
  toggleDuplicateProjectModal,
  updateProject,
  leaveProject,
  deleteProject,
  getProjectById
} from '../../../../actions';
import {
  isChatOpen,
  isListView,
  isTicketOpen,
  isUserDrawerOpen,
  setTeamsState,
} from '../../../../actions/toggleAction';
import { getOrgLicense } from '../../../../js/functions';
import { PROJECT_ICON_COLOURS } from '../../../../js/constants';
import UserAvatar from '../../atoms/ticket-drawer/UserAvatar';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTaskAction } from '../../../../redux/tasks/actions';
import { getOpenedTask } from '../../../../redux/tasks/taskEntities/selectors';

import LinkWithPersistedParams from '../../atoms/linkWithPersistedParams/LinkWithPersistedParams';
import ConfirmationModal from '../modals/ConfirmationModal';
import { toggleEditProjectDetailsModal, togglePortfolioModal } from '../../../../actions/modalAction';
import { pinItemToWorkspace } from '../../../../actions/userAction';
import {
  toggleNewTaskModal,
  toggleWorkspaceFieldsModal,
  toggleInviteToProjectModal,
  joinProject,
} from '../../../../actions';
import GroupAvatar from '../../atoms/side-navbar/GroupAvatar';

const TopNavbar = (props) => {
  const intl = useIntl();
  const notificationOverlayRef = useRef(null);
  const bellIconRef = useRef(null);
  const param = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get('query') || '';

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { chats } = useSelector((state) => state.chatReducer);
  const chat = chats && chats.find((chat) => chat._id === param.chatId);

  const { user: loggedInUser, projectData, workspaceRole, setSidebarOpen } = props;
  const isMember = workspaceRole == 'member' || workspaceRole == 'guest';

  const [open, setOpen] = useState(false);
  const [isLeaveProject, setIsLeaveProject] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [projectUser, setProjectUser] = useState(null);
  const [isOwnerOrAdmin, setIsOwnerOrAdmin] = useState(false)

  const URL = window.location.pathname;

  useEffect(() => {
    if (projectData?.participants && loggedInUser?._id) {
      const user = projectData.participants.find(
        (mem) => mem?._id?.toString() === loggedInUser?._id?.toString()
      );
      setProjectUser(user);
      setIsOwnerOrAdmin(user?.role === 'owner' || user?.role === 'admin');
    }
  }, [projectData, loggedInUser]);

  useEffect(() => {
    const checkIfClickedOutside = (event) => {
      if (
        isNotificationOpen &&
        notificationOverlayRef?.current &&
        !notificationOverlayRef?.current.contains(event.target) &&
        !bellIconRef?.current.contains(event.target)
      ) {
        setIsNotificationOpen(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isNotificationOpen]);

  let member = chat?.members.find(
    (member) => member._id !== localStorage.getItem('Id')
  );

  let primaryTimezone =
    loggedInUser &&
    loggedInUser.timezones &&
    loggedInUser.timezones.find((tz) => tz.isPrimary);
  primaryTimezone = primaryTimezone && primaryTimezone.name;

  const toggleProjectAccess = async () => {
    const access = props?.projectData?.access == "private" ? "public" : "private";
    const projectId = props?.projectData?._id;
    await dispatch(editProject({ _id: projectId, access }));
    // editProject already updates project state — no need to refetch entire workspace
  };

  const updateProjPreferences = async () => {
    await dispatch(updateProjectPreferences({ ...projectUser, notifications: !projectUser?.notifications, projectId: props?.projectData?._id }));
    // Preference update is user-specific — no workspace data changes
  }

  const updateProjectInfo = async (value) => {
    await dispatch(updateProject({ _id: projectData?._id, metadata: value }));
    await dispatch(getProjectById(projectData?._id))
  }

  const portfolios = projectData?.portfolios;

  const colorsSubmenu = [{
    key: 'color-icon-picker',
    className: 'color-picker-no-hover',
    label: (
      <div className="w-56 !hover:bg-purple-500" onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: 'transparent' }}>
        <div>
          <h4 className="text-sm font-medium mb-2 text-gray-700">
            <FormattedMessage id="COLOR" defaultMessage="Color" />
          </h4>
          <div className="grid grid-cols-8 gap-1">
            {PROJECT_ICON_COLOURS.map((colour, index) => {
              const isSelected = projectData?.metadata?.colour === colour;
              return (
                <div
                  key={index}
                  className="size-6 rounded-full cursor-pointer flex items-center justify-center transition-transform hover:scale-110"
                  style={{
                    backgroundColor: colour,
                    outline: isSelected ? `3px solid ${colour}` : '2px solid transparent',
                    outlineOffset: '2px',
                  }}
                  onClick={() => updateProjectInfo({ ...projectData?.metadata, colour })}
                >
                  {isSelected && (
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M2 5l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    ),
    style: { cursor: 'default' },
  },
  ]

  const projectDropdownItems = [
    (isOwnerOrAdmin && {
      key: '1',
      label: (
        <div className="flex toggle-dropdown" onClick={() => {
          dispatch(
            toggleEditProjectDetailsModal(true, projectData),
          );
        }}>
          <img className="size-4" src="/images/icons/Edit.svg" alt="" />
          <div><FormattedMessage id="EDIT_PROJECT_DETAILS" defaultMessage="Edit Project Details" /></div>
        </div>
      ),
    }),
    (isOwnerOrAdmin && {
      key: '2',
      label: (
        <div className="flex toggle-dropdown">
          <div className="size-4 rounded-full border-2 border-white shadow-sm" style={{ background: projectData?.metadata?.colour || '#6366f1', outline: `2px solid ${projectData?.metadata?.colour || '#6366f1'}44` }} />
          <div><FormattedMessage id="SET_COLOR" defaultMessage="Set Color" /></div>
        </div>
      ),
      children: colorsSubmenu,
    }),
    (isOwnerOrAdmin && { type: 'divider' }),
    (isOwnerOrAdmin && {
      key: '3',
      label: (
        <div className="flex toggle-dropdown" onClick={() => {
          dispatch(toggleDuplicateProjectModal(true, projectData));
        }}>
          <img className="size-4" src="/images/icons/duplicate.svg" alt="" />
          <div><FormattedMessage id="DUPLICATE_PROJECT" defaultMessage="Duplicate Project" /></div>
        </div>
      ),
    }),
    {
      key: '4',
      label: (
        <div className="flex toggle-dropdown" onClick={() => {
          navigator.clipboard.writeText(
            `${window.location.origin}/${projectData._id}/board`,
          );
          notification.success({
            message: intl.formatMessage({
              id: 'PROJECT_LINK_COPIED',
              defaultMessage:
                'Project link copied to clipboard',
            }),
            placement: 'bottomRight',
          });
        }}>
          <img className="size-4" src="/images/icons/copy.svg" alt="" />
          <div><FormattedMessage id="COPY_PROJECT_LINK" defaultMessage="Copy Project Link" /></div>
        </div>
      ),
    },
    { type: 'divider' },
    {
      key: '5',
      label: (
        <div className="flex justify-between" onClick={updateProjPreferences}>
          <div className="flex toggle-dropdown">
            <img className="size-4" src="/images/icons/notification.svg" alt="" />
            <div><FormattedMessage id="NOTIFICATIONS" defaultMessage="Notifications" /></div>
          </div>
          <Switch size='small' checked={projectUser?.notifications} />
        </div>
      ),
    },
    {
      key: '6',
      label: (
        <div className="flex justify-between" onClick={toggleProjectAccess}>
          <div className="flex toggle-dropdown">
            <img className="size-4" src="/images/icons/lock.svg" alt="" />
            <div><FormattedMessage id="MAKE_PRIVATE" defaultMessage="Make Private" /></div>
          </div>
          <Switch size='small' checked={props?.projectData?.access !== 'public'} />
        </div>
      ),
    },
    { type: 'divider' },
    // {
    //   key: '7',
    //   label: (
    //     <div className="flex items-center justify-between">
    //       <FormattedMessage id="IMPORT" defaultMessage="Import" />
    //       <RightOutlined className="text-xs -mr-3" />
    //     </div>
    //   ),
    //   children: [
    //     {
    //       key: 'import:csv',
    //       label: (
    //         <div className="flex w-[8rem]">
    //           <FormattedMessage id="CSV" defaultMessage="CSV" />
    //         </div>
    //       ),
    //     },
    //     {
    //       key: 'import:email',
    //       label: (
    //         <div className="flex w-[8rem]">
    //           <FormattedMessage id="EMAIL" defaultMessage="Email" />
    //         </div>),
    //     },
    //   ],
    // },
    // {
    //   key: '8',
    //   label: (
    //     <div className="flex items-center justify-between w-full">
    //       <FormattedMessage id="EXPORT" defaultMessage="Export" />
    //       <RightOutlined className="text-xs -mr-3" />
    //     </div>
    //   ),
    //   children: [
    //     {
    //       key: 'export:csv',
    //       label: (
    //         <div className="flex w-[8rem]">
    //           <FormattedMessage id="CSV" defaultMessage="CSV" />
    //         </div>)
    //     },
    //     {
    //       key: 'export:JSON',
    //       label: (
    //         <div className="flex w-[8rem]">
    //           <FormattedMessage id="JSON" defaultMessage="JSON" />
    //         </div>),
    //     },
    //   ],
    // },
    (isOwnerOrAdmin && {
      key: '9',
      label: (
        <div className="flex toggle-dropdown" onClick={() => {
          setIsArchive(true);
          setOpen(true)
        }
        } >
          <div className="flex toggle-dropdown" onClick={() => setOpen(true)}>
            <img className="size-4" src="/images/icons/project.svg" alt="" />
            <FormattedMessage
              id={projectData?.archived ? 'UNARCHIVE_PROJECT' : 'ARCHIVE_PROJECT'}
              defaultMessage="Archive Project"
            />
          </div>
        </div>
      ),
    }),
    (isOwnerOrAdmin ? {
      key: '10',
      label: (
        <div className="flex toggle-dropdown" onClick={() => setOpen(true)}>
          <img className="size-4" src="/images/icons/delete-red.svg" alt="" />
          <div style={{ color: 'red' }}>
            <FormattedMessage id="DELETE_PROJECT" defaultMessage="Delete Project" />
          </div>
        </div>
      ),
    } : {
      key: '11',
      label: (
        <div className="flex toggle-dropdown" onClick={() => {
          setIsLeaveProject(true);
          setOpen(true);
        }}>
          <img className="size-4" src="/images/icons/Exit.svg" alt="" />
          <div style={{ color: '#f43f5e' }}>
            <FormattedMessage id="LEAVE_PROJECT" defaultMessage="Leave Project" />
          </div>
        </div>
      ),
    }),
  ];


  const isGuest = props.workspaceRole === 'guest';
  const hasRequests = projectData?.accessRequests?.length > 0;
  const currentUserId = props.user?._id;
  const isJoined = props.myProjects?.some((p) => p?._id === projectData?._id);
  const isPublicAndNotJoined = props.myProjects == null ? null : !isJoined;

  const projectLinks = () => {
    const baseUrl = `/${URL.split('/')[1]}`;
    return (
      <div className="flex items-center h-full flex-1 min-w-0 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
        <LinkWithPersistedParams to={`${baseUrl}/overview`} className='topNavbarLink overviewTopNavbarLink'>
          <img src='/images/icons/overview.svg' alt='' className='size-3.5' />
          <FormattedMessage id="OVERVIEW" defaultMessage="Overview" />
        </LinkWithPersistedParams>
        <LinkWithPersistedParams to={`${baseUrl}/calendar`} className='topNavbarLink calendarTopNavbarLink'>
          <img src='/images/icons/date.svg' alt='' className='size-3.5' />
          <FormattedMessage id="CALENDAR" defaultMessage="Calendar" />
        </LinkWithPersistedParams>
        <LinkWithPersistedParams onClick={() => dispatch(isListView(false))} to={`${baseUrl}/board`} className='topNavbarLink boardTopNavbarLink'>
          <img src='/images/icons/board-gray.svg' alt='' className='size-3.5' />
          <FormattedMessage id="BOARD" defaultMessage="Board" />
        </LinkWithPersistedParams>
        <LinkWithPersistedParams onClick={() => dispatch(isListView(true))} to={`${baseUrl}/list`} className='topNavbarLink listTopNavbarLink'>
          <img src='/images/icons/list.svg' alt='' className='size-3.5' />
          <FormattedMessage id="LIST" defaultMessage="List" />
        </LinkWithPersistedParams>
        <LinkWithPersistedParams to={`${baseUrl}/form`} className='topNavbarLink formTopNavbarLink'>
          <img src='/images/icons/task.svg' alt='' className='size-3.5' />
          <FormattedMessage id="FORMS" defaultMessage="Forms" />
        </LinkWithPersistedParams>
        <LinkWithPersistedParams to={`${baseUrl}/settings`} className='topNavbarLink settingsTopNavbarLink'>
          <img src='/images/icons/settings.svg' alt='' className='size-3.5' />
          <FormattedMessage id="SETTINGS" defaultMessage="Settings" />
        </LinkWithPersistedParams>

        {/* Action buttons — right side of tab bar */}
        <div className="flex items-center gap-2 ml-auto pl-4 flex-shrink-0">
          <div className="h-4 w-px bg-gray-200" />
          {!isGuest && (
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'add-task',
                    label: <div className="text-sm py-1"><FormattedMessage id="ADD_TASK" defaultMessage="Add Task" /></div>,
                    onClick: () => dispatch(toggleNewTaskModal({ value: true })),
                  },
                  {
                    key: 'add-custom-field',
                    label: <div className="text-sm py-1"><FormattedMessage id="ADD_CUSTOM_FIELD" defaultMessage="Add Custom Field" /></div>,
                    onClick: () => dispatch(toggleWorkspaceFieldsModal(true)),
                  },
                  {
                    key: 'add-member',
                    label: <div className="text-sm py-1">Add Member</div>,
                    onClick: () => dispatch(toggleInviteToProjectModal(true)),
                  },
                  ...(URL.endsWith('/board') ? [{
                    key: 'add-section',
                    label: <div className="text-sm py-1">Add Section</div>,
                    onClick: () => window.dispatchEvent(new Event('workflo:add-section')),
                  }] : []),
                ],
              }}
              placement="bottomRight"
              trigger={['click']}
            >
              <button type="button" className="flex items-center gap-1.5 h-7 px-3 rounded-md text-white text-xs font-medium whitespace-nowrap transition-all duration-150" style={{ background: '#4f46e5', boxShadow: '0 1px 4px rgba(79,70,229,0.25)' }} onMouseEnter={e => e.currentTarget.style.background = '#4338ca'} onMouseLeave={e => e.currentTarget.style.background = '#4f46e5'}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-3.5">
                  <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                </svg>
                <span className="hidden lg:block"><FormattedMessage id="ADD_TO_PROJECT" defaultMessage="Add to project" /></span>
              </button>
            </Dropdown>
          )}
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => {
              if (isPublicAndNotJoined) {
                dispatch(joinProject({ projectId: projectData?._id, role: 'member', isPublic: projectData?.access === 'public' }));
              } else {
                dispatch(toggleInviteToProjectModal(true));
              }
            }}
          >
            <div className="hidden lg:block">
              <GroupAvatar participants={projectData?.participants} size={26} count={3} />
            </div>
            <button
              type="button"
              className={`h-7 px-3 rounded-md text-xs font-medium text-white whitespace-nowrap transition-all duration-150`}
              style={hasRequests ? { background: '#ef4444', boxShadow: '0 1px 4px rgba(239,68,68,0.25)' } : { background: '#4f46e5', boxShadow: '0 1px 4px rgba(79,70,229,0.25)' }}
              onMouseEnter={e => e.currentTarget.style.background = hasRequests ? '#dc2626' : '#4338ca'}
              onMouseLeave={e => e.currentTarget.style.background = hasRequests ? '#ef4444' : '#4f46e5'}
            >
              {isPublicAndNotJoined === null ? (
                <div className="w-10 h-3.5 rounded-full bg-white/50 animate-pulse" />
              ) : isPublicAndNotJoined ? (
                <FormattedMessage id="JOIN" defaultMessage="JOIN" />
              ) : hasRequests ? (
                <FormattedMessage id="VIEW_REQUESTS" defaultMessage="View Requests!" />
              ) : isGuest ? (
                <FormattedMessage id="MEMBERS" defaultMessage="Members" />
              ) : (
                <FormattedMessage id="INVITE" defaultMessage="Invite" />
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  const license = getOrgLicense(loggedInUser, sessionStorage.getItem("organization") || localStorage.getItem("organization"))

  return (
    <>
      <ConfirmationModal
        title={isArchive ? <FormattedMessage id={projectData?.archived ? 'UNARCHIVE_PROJECT_CONFIRMATION' : "ARCHIVE_PROJECT_CONFIRMATION"} defaultMessage="Archive Project?" />
          : (isLeaveProject
            ? <FormattedMessage id="LEAVE_PROJECT_CONFIRMATION" defaultMessage="Leave Project?" />
            : <FormattedMessage id="DELETE_PROJECT_CONFIRMATION" defaultMessage="Delete Project?" />)
        }
        description={isArchive ? <FormattedMessage id={projectData?.archived ? 'UNARCHIVE_PROJECT__TASK_CONFIRMATION_DESCRIPTION' : "ARCHIVE_PROJECT__TASK_CONFIRMATION_DESCRIPTION"} defaultMessage="Are you sure you want to archive {projectTaskTitle}?" values={{ projectTaskTitle: projectData?.title }} /> : (isLeaveProject
          ? <FormattedMessage id="LEAVE_PROJECT_CONFIRMATION_DESCRIPTION" defaultMessage="Are you sure you want to leave {projectTitle}?" values={{ projectTitle: projectData?.title }} />
          : <FormattedMessage id="DELETE_PROJECT_CONFIRMATION_DESCRIPTION" defaultMessage="Are you sure you want to delete {projectTitle}?" values={{ projectTitle: projectData?.title }} />)}
        isModalOpen={open}
        onCancel={() => { setOpen(false); setIsArchive(false); setIsLeaveProject(false); }}
        onYesClick={() => {
          if (isArchive) {
            dispatch(updateProject({ _id: projectData?._id, archived: !projectData?.archived }))
            setIsArchive(false);
            setOpen(false);
            return;
          } else if (isLeaveProject) {
            dispatch(leaveProject({ projectId: projectData?._id }))
          } else {
            dispatch(deleteProject(projectData?._id));
          }
          setOpen(false);
          navigate('/', { replace: true });
        }}
      />
      <header className="sticky top-0 z-30" style={{ background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(99,102,241,0.1)' }}>
        <div className="px-4 sm:px-6 lg:px-8">
          <div className={`${props.phase !== 'search' ? 'justify-between' : 'justify-normal'} flex align-center h-16 -mb-px`}>

            {/* Header: Left side (hamburger + content grouped so justify-between doesn't center them) */}
            <div className="flex items-center min-w-0">
              <button
                className="xl:hidden flex items-center justify-center mr-3 p-1 rounded hover:bg-gray-100"
                onClick={() => setSidebarOpen?.(true)}
                aria-label="Open menu"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5H17M3 10H17M3 15H17" stroke="#374151" strokeWidth="1.75" strokeLinecap="round" />
                </svg>
              </button>
              <div className="flex min-w-0">
                {props.phase === 'chat' && (
                  <div className='d-flex align-center'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      dispatch(isChatSettingsOpen(true));
                    }}>
                    <div key={member ? member._id : ''}>
                      {((chat?.roomAvi || member?.avi) && chat.roomType !== 'project') ?
                        <ProfileAndName
                          height='30px'
                          width='30px'
                          name={
                            chat?.roomName !== null && chat?.roomName !== ''
                              ? chat?.roomName
                              : member?.fullName
                          }
                          src={
                            chat && chat.roomType == 'group'
                              ? chat.roomAvi
                              : member && member.avi
                          }
                          imageOverwrite={true}
                          id={member ? member?._id : ''}
                        /> :
                        <div className='d-flex align-center'>
                          <div className='square-letter-large'
                            style={{
                              background: 'red',
                            }}>
                            {(chat?.roomName !== null && chat?.roomName !== ''
                              ? chat?.roomName
                              : member?.fullName)?.slice(0, 2)}
                          </div>
                          <div className='flex align-center'>
                            <div className='font-20 truncate'>
                              {chat?.roomName !== null && chat?.roomName !== ''
                                ? chat?.roomName
                                : member?.fullName}
                            </div>
                            <img
                              className='hover:opacity-60'
                              src={'/images/icons/info.svg'}
                              style={{
                                cursor: 'pointer',
                                height: '22px',
                                width: '22px',
                              }}
                              alt='icon'
                            />
                          </div>
                        </div>}
                    </div>
                  </div>
                )}

                {/*............. Project top navbar............... */}
                {props.phase === 'project' && (
                  <div className="flex items-center gap-2.5 min-w-0">
                    {/* Project color icon */}
                    <div
                      className="size-8 rounded-lg flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: projectData?.metadata?.colour || '#4f46e5', boxShadow: `0 0 0 2px ${projectData?.metadata?.colour || '#4f46e5'}22` }}
                    >
                      <img src='/images/icons/board.svg' className="size-4" style={{ filter: 'brightness(0) invert(1)', opacity: 0.92 }} alt="" />
                    </div>

                    <div className="flex items-center gap-0.5 min-w-0">
                      <p className="text-[15px] font-semibold truncate max-w-[200px] mb-0" style={{ color: 'rgba(15,15,25,0.8)' }}>
                        {props.name}
                      </p>

                      <Dropdown trigger={['click']} menu={{ items: projectDropdownItems }} placement='bottom' arrow>
                        <button type="button" className="flex items-center justify-center size-6 rounded hover:bg-gray-100 flex-shrink-0 cursor-pointer ml-0.5">
                          <img src={'/images/icons/black-arrow-down.svg'} className="size-3" alt="" />
                        </button>
                      </Dropdown>

                      <button
                        type="button"
                        className="flex items-center justify-center size-6 rounded hover:bg-gray-100 flex-shrink-0 hidden lg:flex cursor-pointer"
                        onClick={() => dispatch(pinItemToWorkspace({ entityId: projectData?._id, entityType: "project", workspaceId: props?.currentWorkspace?._id }, !projectData?.pinned, projectData))}
                      >
                        {projectData?.pinned
                          ? <Icon name='starBlue.svg' height='16px' width='16px' />
                          : <Icon name='star.svg' height='15px' width='15px' />}
                      </button>

                      {props?.projectData?.access === "private" && (
                        <span className="flex items-center flex-shrink-0 ml-0.5 opacity-50">
                          <Icon name='lock.svg' height='14px' width='14px' />
                        </span>
                      )}

                      {portfolios?.length > 0 && (
                        <div className="hidden xl:flex items-center gap-1 ml-2 min-w-0">
                          <div className="h-3.5 w-px bg-gray-300 flex-shrink-0" />
                          {portfolios?.slice(0, 3)?.map(portfolio => (
                            <button
                              key={portfolio?._id}
                              type="button"
                              className="text-[11px] text-blue-600 hover:underline cursor-pointer whitespace-nowrap px-1"
                              onClick={() => navigate(`/portfolio/${portfolio?._id}`)}
                            >
                              {portfolio?.name}
                            </button>
                          ))}
                          {portfolios?.length > 3 && (
                            <Dropdown
                              trigger={['click']}
                              menu={{ items: portfolios?.slice(3)?.map(p => ({ key: p?._id, label: p?.name, onClick: () => navigate(`/portfolio/${p?._id}`) })) }}
                              placement='bottom'
                              arrow
                            >
                              <button type="button" className="flex items-center justify-center size-5 rounded hover:bg-gray-100 cursor-pointer">
                                <img src={'/images/icons/threeDots.svg'} className="size-3" alt="" />
                              </button>
                            </Dropdown>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {(props.phase === 'account-management') && (
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ background: 'linear-gradient(135deg, #4f46e5, #7c3aed)' }}>
                      {(props?.name || props?.currentWorkspace?.title || '').slice(0, 2).toUpperCase()}
                    </div>
                    <div>
                      <div className="text-[15px] font-semibold text-gray-900">{props.name || props?.currentWorkspace?.title}</div>
                      <div className="text-xs text-gray-400 hidden lg:block">
                        <FormattedMessage id="BILLING_AND_INVOICES" defaultMessage="Billing" />
                      </div>
                    </div>
                  </div>
                )}

                {(props.phase === 'integrations') && (
                  <div>
                    <div className="text-[15px] font-semibold text-gray-900">
                      <FormattedMessage id="INTEGRATIONS_AND_API" defaultMessage="Integrations & API" />
                    </div>
                    <div className="text-xs text-gray-400 hidden lg:block">
                      <FormattedMessage id="INTEGRATIONS_SUBTITLE" defaultMessage="AI assistants, connected apps and access tokens" />
                    </div>
                  </div>
                )}

                {(props.phase === 'report') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="Report" defaultMessage="Report" />
                  </span>
                )}

                {/*............. Team top navbar............... */}
                {(props.phase === 'workspace') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="HOME" defaultMessage="Home" />
                  </span>
                )}

                {(props.phase === 'dashboard') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="DASHBOARD" defaultMessage="Dashboard" />
                  </span>
                )}

                {(props.phase === 'teams') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="TEAMS_DIRECTORY" defaultMessage="Teams Directory" />
                  </span>
                )}

                {(props.phase === 'activity') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="ACTIVITY" defaultMessage="Activity" />
                  </span>
                )}

                {(props.phase === 'forms') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="FORMS" defaultMessage="Forms" />
                  </span>
                )}

                {(props.phase === 'browse-projects') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="BROWSE_PROJECTS" defaultMessage="Browse Projects" />
                  </span>
                )}


                {(props.phase === 'profile') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="MEMBER_PROFILE" defaultMessage="Member Profile" />
                  </span>
                )}

                {(props.phase === 'portfolio') && (
                  <div className="flex items-center gap-3">
                    <div>
                      <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                        <FormattedMessage id="PORTFOLIO" defaultMessage="Portfolios" />
                      </span>
                      <p className="text-xs" style={{ color: 'rgba(15,15,25,0.4)', lineHeight: 1.2 }}>Group and track your projects across initiatives</p>
                    </div>
                  </div>
                )}

                {(props.phase === 'search-results') && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="SEARCH_RESULTS_FOR" defaultMessage="Search Results For" />{' '}"{query}"
                  </span>
                )}

                {/*.............Home top navbar............... */}


                {props.phase === 'home' && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="HOME" defaultMessage="Home" />
                  </span>
                )}

                {props.phase === 'all-tasks' && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="TASKS" defaultMessage="Tasks" />
                  </span>
                )}

                {props.phase === 'calendar' && (
                  <span className="text-[15px] font-semibold" style={{ color: 'rgba(15,15,25,0.8)' }}>
                    <FormattedMessage id="CALENDAR" defaultMessage="Calendar" />
                  </span>
                )}
              </div>
            </div>

            {/* Header: Right side */}
            <div className={`flex items-center justify-between ${props.phase !== 'search' ? 'space-x-3 w-auto' : 'space-x-0 w-full'}`}>
              {props.phase === 'portfolio' && (
                <button
                  onClick={() => dispatch(togglePortfolioModal(true))}
                  className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm text-white font-medium transition-opacity"
                  style={{ background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', boxShadow: '0 2px 8px rgba(99,102,241,0.35)' }}
                  onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
                  onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                  <FormattedMessage id="NEW_PORTFOLIO" defaultMessage="New Portfolio" />
                </button>
              )}
              <div className={`${props.phase !== 'search' ? '' : 'flex justify-center items-center w-[100vw]'}`}>
                <WorkspaceSearchBar header search={props.phase !== 'search' ? false : true} />
              </div>
              {/*  Divider */}
              {license === 'Free Plan' && !isMember && <div style={{ margin: '0 10px 0 25px' }} className={`${props.phase !== 'search' ? '' : 'xl:block hidden'}`}>
                <div className='text-xs md:text-sm text-[#27282D]'><FormattedMessage id="FREE_PLAN" defaultMessage="Free Plan" /></div>
                <div className='d-flex align-center' style={{ cursor: 'pointer' }} onClick={() => navigate('/pricing')}>
                  <div className='text-xs link-button mr-2'><FormattedMessage id="UPGRADE" defaultMessage="Upgrade" /></div>
                  <img src='/images/icons/blue-arrow-right.svg' className='size-3' />
                </div>
              </div>}
              {/*  Divider */}
              <hr className="w-px h-6 bg-[#E2E8F0] border-none xl:block hidden" />

              <div className={`xl:flex  flex align-center cursor-pointer`} onClick={() => dispatch(isUserDrawerOpen(true))}>
                <UserAvatar
                  fullName={loggedInUser?.fullName}
                  userId={loggedInUser?._id}
                  src={loggedInUser?.avi}
                  styles={{
                    height: '34px',
                    width: '34px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      </header>
      {props.phase === 'project' && (
        <nav className="sticky top-16 z-20 h-11 flex items-center px-3" style={{ background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(99,102,241,0.08)' }}>
          {projectLinks()}
        </nav>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  const pathName = window.location.pathname.split('/')[2];
  return {
    getWorkspaceNotifications: () => dispatch(getWorkspaceNotifications()),
    teamsOpener: (arg) => dispatch(setTeamsState(arg)),
    chatOpener: (arg) => dispatch(isChatOpen(arg)),
    taskOpener: (arg) => dispatch(isTicketOpen(arg)),
    getUser: () => dispatch(getUser()),
    getCurrentTask: () =>
      pathName !== 'board' && dispatch(getTaskAction(pathName)),
  };
};

const mapStateToProp = (state) => {
  return {
    user: state.userReducer.user,
    notifications: state.notificationReducer.notifications,
    currentTask: getOpenedTask(state),
    currentWorkspace: state.workspaceReducer.currentWorkspace,
    workspaceRole: state.userReducer.role,
    myProjects: state.projectReducer.myProjects,
  };
};
export default connect(mapStateToProp, mapDispatchToProps)(TopNavbar);
